import { useHistory } from 'react-router-dom';

type LogoSize = 'sm' | 'md' | 'lg';

const cfg: Record<LogoSize, { circle: number; tag: string; open: string }> = {
  sm: { circle: 28, tag: '0.58rem', open: '1.05rem' },
  md: { circle: 36, tag: '0.75rem', open: '1.4rem' },
  lg: { circle: 52, tag: '1.05rem', open: '2.1rem' },
};

export function Logo({ size = 'md', theme = 'light' }: { size?: LogoSize; theme?: 'light' | 'dark' }) {
  const history = useHistory();
  const c = cfg[size];
  const openColor = theme === 'dark' ? 'white' : '#1a56a0';
  const circleColor = theme === 'dark' ? 'rgba(255,255,255,0.15)' : '#1a1a1a';
  const tagColor = theme === 'dark' ? 'white' : 'white';
  return (
    <button
      onClick={() => history.push('/')}
      className="flex items-center gap-1.5 select-none focus:outline-none"
      aria-label="Go to home"
    >
      <span style={{ fontWeight: 900, fontSize: c.open, color: openColor, letterSpacing: '-0.02em', lineHeight: 1, fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
        OPEN
      </span>
      <div
        style={{ background: circleColor, borderRadius: '50%', width: c.circle, height: c.circle, flexShrink: 0 }}
        className="flex items-center justify-center"
      >
        <span style={{ fontWeight: 800, fontSize: c.tag, color: tagColor, letterSpacing: '-0.03em', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
          iPub
        </span>
      </div>
    </button>
  );
}
